<nw-card [disabled]="true" class="highlight-card" (raiseEvent)="raiseEvent.emit($event)">
    <div class="highlight-card__indicator"></div>
    <div role="header">
        <ng-content select="[role=header]"></ng-content>
    </div>
    <div role="body">
        <ng-content select="[role=body]"></ng-content>
    </div>
</nw-card>
